import * as React from "react";
import { ActivateAccountForm } from "./activate-account-form";
import bgRegister from "../../assets/bgRegister.jpg";
import { IdCard } from "lucide-react";

export interface IActivateAccountProps {}

export const ActivateAccount: React.FC<IActivateAccountProps> = () => {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-center bg-fixed relative overflow-hidden"
      style={{ backgroundImage: `url(${bgRegister})` }}
    >
      <div className="absolute inset-0 bg-black opacity-60 z-0" />{" "}
      <div className="relative w-full sm:max-w-lg lg:max-w-xl p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10 my-4">
        <div className="flex items-center space-x-2 mb-6 justify-center">
          <IdCard className="h-6 w-6 text-gray-800" />
          <h1 className="text-2xl font-bold text-gray-800">Activar Cuenta</h1>
        </div>

        <p className="text-gray-700 mb-4">
          Ingrese sus datos para activar su cuenta.
        </p>

        <ActivateAccountForm />
      </div>
    </div>
  );
};
